import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { CmsProvider } from './context/CmsContext'
import ScrollToTop from './components/ScrollToTop'
import Header from './components/Header'
import Footer from './components/Footer'
import HomePage from './pages/HomePage'
import GalleryPage from './pages/GalleryPage'
import TattoosPage from './pages/TattoosPage'
import AboutPage from './pages/AboutPage'
import BookingPage from './pages/BookingPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

export default function App() {
  return (
    <CmsProvider>
      <div className="flex flex-col min-h-screen bg-[#0f1013] text-[#f4f3f0] selection:bg-[#cbb05e] selection:text-[#0f1013]">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/galleri" element={<GalleryPage />} />
            <Route path="/tatoveringer" element={<TattoosPage />} />
            <Route path="/om-docuit-ink" element={<AboutPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/403" element={<ForbiddenPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </CmsProvider>
  )
}
